module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I would like to acknowledge Fay Jeffery, my mother, who has instilled the qualities of perseverance, determination, and strength in me.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I would also like to acknowledge my daughter Jody Hosang for her assistance with providing technological support; and Rolando Wilson, my dear friend, for his listening ear during the writing process.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To my eldest daughter, Sue-Jen Osei, I wish you strength and perseverance as you try to overcome your first major hurdle in this game of life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0